// extracted by css-extract-rspack-plugin
export default {"MarkdownViewerContainer":"MarkdownViewer-module__MarkdownViewerContainer__Bo4Rt"};